import {useCallback, useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'i18n'
import {requestData} from 'services'
import {showSnackbar} from 'utils/components'

export function useTransactionPaymentProofHooks({
  invoice_id,
  payment_invoice,
}: {
  invoice_id: string
  payment_invoice: string
}) {
  const stateSendProofModal = useState(false)
  const stateSendProofLoading = useState(false)
  const stateSendProofSent = useState<boolean>()

  const setSendProofModal = stateSendProofModal[1]
  const setSendProofLoading = stateSendProofLoading[1]
  const setSendProofSent = stateSendProofSent[1]
  const {translate} = useTranslation()

  const handleCheckPaymentProofIsSent = useCallback(() => {
    if (invoice_id === '') return

    requestData('giftshop_get_transaction_report', {
      params: {
        invoice_id,
      },
      onRequestSuccess: ({status: stat}) => {
        setSendProofSent(stat === 200)
      },
    })
  }, [invoice_id, setSendProofSent])

  const handleSubmitPaymentProof = useCallback(
    (file: File, notes?: string) => {
      setSendProofLoading(true)
      requestData('giftshop_post_transaction_report', {
        useDefaultMessage: true,
        actionType: 'execute',
        headerContentType: 'multipart/form-data',
        dataType: 'form-data',
        data: {
          payment_invoice,
          notes,
          receipt_photo: file,
        },
        onRequestSuccess: ({status: paymentProofStatus}) => {
          setSendProofLoading(false)
          if (paymentProofStatus === 200) {
            setSendProofModal(false)
            setSendProofLoading(false)
            setSendProofSent(true)
            showSnackbar(translate('giftShop:paymentSendProofSuccess'))
          }
        },
        onRequestFailed: () => {
          setSendProofLoading(false)
          showSnackbar(translate('giftShop:paymentSendProofFailed'))
        },
      })
    },
    [
      payment_invoice,
      setSendProofLoading,
      setSendProofModal,
      setSendProofSent,
      translate,
    ],
  )

  useEffect(() => {
    handleCheckPaymentProofIsSent()
  }, [handleCheckPaymentProofIsSent])

  return useMemo(
    () => ({
      stateSendProofLoading,
      stateSendProofModal,
      stateSendProofSent,
      handleSubmitPaymentProof,
      handleCheckPaymentProofIsSent,
    }),
    [
      handleCheckPaymentProofIsSent,
      handleSubmitPaymentProof,
      stateSendProofLoading,
      stateSendProofModal,
      stateSendProofSent,
    ],
  )
}
